export default __webpack_public_path__ + "static/media/tickmarkIcon.2bc3004a.svg";